import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { NavigateFunction } from 'react-router-dom';

export const getAccessToken = () => {
  return Cookies.get('ca_token');
};

export function convertStringToDate(dateString: string | null) {
  if (dateString === null || undefined) {
    return new Date();
  }
  const [day, month, year] = dateString.split('/').map(Number); // Split and convert to numbers
  return new Date(year, month - 1, day); // Month is zero-based
}

export const stringToSha256Hash = (inputString: string) => {
  const hashedText = CryptoJS.SHA256(inputString);
  const hexHash = hashedText.toString(CryptoJS.enc.Hex);
  return hexHash;
};

export const isTokenExpired = (token: string) => {
  if (!token) return true;
  try {
    // console.log(JSON.parse(atob(token)));
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

/**
 * Navigate to appropriate page based on city and loungeId.
 * Uses route-based navigation instead of query parameters.
 *
 * @param navigate - React Router navigate function
 * @param loungeId - Optional lounge ID to include in URL
 * @param city - Optional city to include in URL
 */
export const navigateToHomeWithLounge = (
  navigate: NavigateFunction,
  loungeId?: string | null,
  city?: string | null,
) => {
  if (loungeId) {
    navigate(`/booking/${loungeId}${city ? `?city=${city}` : ''}`);
  } else if (city) {
    navigate(`/select-lounge/${city}`);
  } else {
    navigate('/');
  }
};
